import { getStoreId } from "$/hooks/use-store-information"
import chatQueries from "$/lib/queries/chat-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/messages")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()

    if (storeId) queryClient.prefetchQuery(chatQueries.list({ storeId }))
    return { crumb: "alfred.pages.messages.crumbs.messages" }
  },
})
